import createAuth0Client from "@auth0/auth0-spa-js";
import axios from "axios";
import { RoleNames } from "./RoleNames";

export default class AuthUtil {
  public loggedIn = false;
  public user: any = null;
  public auth0Client!: any;

  public async init(options: any): Promise<void> {
    this.auth0Client = await createAuth0Client(options);
  }

  public async login(path: string): Promise<void> {
    console.log(await this.auth0Client.isAuthenticated());
    if (await this.auth0Client.isAuthenticated()) {
      const token = await (await this.auth0Client.getIdTokenClaims()).__raw;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      console.log(token);
      console.log(await this.auth0Client.getUser());
      console.log(await this.auth0Client.getIdTokenClaims());
      this.loggedIn = true;
      this.user = this.parseUser(await this.auth0Client.getUser());
    } else {
      return await this.auth0Client.loginWithRedirect({
        // eslint-disable-next-line @typescript-eslint/camelcase
        redirect_uri: window.location.origin,
        // eslint-disable-next-line @typescript-eslint/camelcase
        ui_locales: "de",
        appState: { path }
      });
    }
  }
  private parseUser(user: any): any {
    if (user) {
      user.roles = user["http://pitchapi.de/roles"];
    }

    return user;
  }

  public async checkLoggedIn(): Promise<boolean> {
    const result = await this.auth0Client.isAuthenticated();

    return result;
  }

  public async handleRedirectCallback(): Promise<any> {
    return await this.auth0Client.handleRedirectCallback();
  }

  public checkUserRoles(...roles: string[]): boolean {
    if (roles && this.user && this.user.roles) {
      const userRoles = this.user.roles as string[];
      if (userRoles.includes(RoleNames.ADMIN)) {
        return true;
      }
      for (const role of roles) {
        if (userRoles.includes(role)) {
          return true;
        }
      }
    }
    return false;
  }

  public async logout() {
    return this.auth0Client.logout({
      returnTo: window.location.origin
    });
  }
}
